import { scoreBandTextClass } from "@/lib/conditions/score-colour";
import { scoreOutOf100 } from "@/lib/conditions/score-display";

export type ScoreChipProps = {
  score: number | null;
  label?: string | null;
};

export function ScoreChip({ score, label }: ScoreChipProps) {
  const display = score === null || !Number.isFinite(score)
    ? "No score"
    : `${scoreOutOf100(score)}`;
  const title = label?.trim() || null;

  return (
    <span className="inline-flex min-h-[32px] items-center gap-2 rounded-full border border-navy/10 bg-white px-3 py-1 text-[13px] font-semibold shadow-sm">
      <span className={`tabular-nums ${scoreBandTextClass(score)}`}>{display}</span>
      {score !== null && Number.isFinite(score) ? (
        <span className="text-[11px] font-medium text-text-muted">/100</span>
      ) : null}
      {title ? <span className="text-[11px] font-medium text-text-muted">{title}</span> : null}
    </span>
  );
}
